import {Component} from 'react'
import { strings } from '../../i18n'

export default class StatusCode extends Component {

    render = () => {
        const {code} = this.props

        switch (code) {
            case 'PENDING_PAYIN':
                return strings('thirdScreen.status.pendingPayin')
            case 'CANCELED_PAYIN':
                return strings('thirdScreen.status.canceledPayin')
            case 'CANCELED_PAYOUT':
                return strings('thirdScreen.status.canceledPayout')
            case 'DONE_PAYIN':
                return strings('thirdScreen.status.donePayin')
            case 'DONE_TRADE':
                return strings('thirdScreen.status.doneTrade')
            case 'DONE_PAYOUT':
                return strings('thirdScreen.status.donePayout')
            case 'WAIT_TRADE':
                return strings('thirdScreen.status.waitTrade')
            case 'WAIT_PAYOUT':
                return strings('thirdScreen.status.waitPayout')
            case 'ERROR_ORDER':
                return strings('thirdScreen.status.errorOrder')
                case 'WAIT_KYC':
                    return strings('thirdScreen.status.waitKYC')
            default:
                return null
        }

    }
}